import { ReactComponent as ArrowDownIcon } from '@elementary/common-ui/assets/arrow-down-expand.svg';
import { IconButton } from '@mui/material';
import { Flex } from '../Flex';
import SearchField from '../SearchField';
import { TreeViewBy, ValueLabelIconOption } from '../../types';
import Menu from '../Menu';
import SvgIcon from '../SvgIcon';

type Props = {
  search: string;
  onSearch: (val: string) => void;
  treeViewBy: TreeViewBy;
  viewByOptions: ValueLabelIconOption[];
  onViewByChange: (val: string) => void;
  disabled?: boolean;
};

const TreeViewByMenu = ({
  search,
  onSearch,
  treeViewBy,
  viewByOptions,
  onViewByChange,
  disabled,
}: Props) => {
  const selectedOptionIcon = viewByOptions.find(
    (o) => o.value === treeViewBy,
  )?.icon;

  return (
    <Flex
      sx={{
        alignItems: 'center',
        gap: 1,
      }}
    >
      <SearchField
        fullWidth
        onChange={(event) => onSearch(event.target.value)}
        value={search}
        disabled={disabled}
      />

      <Menu
        options={viewByOptions}
        onChange={onViewByChange}
        closeOnChange
        tooltip="View by"
        menuButton={
          <IconButton
            sx={{ borderRadius: 2, opacity: disabled ? 0.5 : 1 }}
            disabled={disabled}
          >
            <Flex
              sx={{
                alignItems: 'center',
                gap: 0.5,
                cursor: 'pointer',
              }}
            >
              {selectedOptionIcon}
              <SvgIcon width={12}>
                <ArrowDownIcon />
              </SvgIcon>
            </Flex>
          </IconButton>
        }
      />
    </Flex>
  );
};

export default TreeViewByMenu;
